import { ACCESS_TOKEN, getItem } from "local-storage";
import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  searchTiktokUsers,
  getTiktokFollowingUser,
  getTiktokUserTrendingUsers,
  subscribe,
  unsubscribe,
  searchFantechUsers,
} from "services/apis/apis";
import { getExploreUrl } from "services/apis/urls";
import useSWR from "swr";

export const useController = () => {
  // const { data: explores } = useSWR(getExploreUrl, getExploreData);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const inputValue = queryParams.get("search") ?? "";

  const [currentTab, setCurrentTab] = useState<"On fan.tech" | "On TikTok">(
    "On fan.tech"
  );
  const [isLoading, setIsLoading] = useState(false);
  const [datas, setDatas] = useState<any[]>([]);
  const [trendingIdols, setTrendingIdols] = useState<any>([]);
  const [isLoadingTrending, setIsLoadingTrending] = useState<any>(true);
  const [val, setVal] = useState(inputValue);

  const handleSearch = useCallback(async () => {
    try {
      const accessToken = getItem(ACCESS_TOKEN) || "";

      if (!accessToken) return;
      setIsLoading(true);
      let res;
      if (currentTab === "On TikTok") {
        res = await searchTiktokUsers(accessToken, val);
      } else {
        res = await searchFantechUsers(accessToken, val);
      }
      setDatas(res);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }, [currentTab, val]);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (val) {
        handleSearch();
      }
    }
  };

  useEffect(() => {
    const f = async () => {
      if (!inputValue) return;
      try {
        const accessToken = getItem(ACCESS_TOKEN) || "";
        if (!accessToken) return;
        setIsLoading(true);
        const res = await searchTiktokUsers(accessToken, inputValue);
        setDatas(res);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };
    f();
    // Only fetch for first mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUnsubscribe = async (userId: string, index: number) => {
    try {
      const accessToken = getItem(ACCESS_TOKEN) || "";

      if (!accessToken) return;
      const updatedDatas = [...trendingIdols];
      updatedDatas[index].isSubscribe = false;
      updatedDatas[index].numFan = updatedDatas[index].numFan - 1;

      setDatas(updatedDatas);

      const result = await unsubscribe(accessToken, userId);

      if (!result) {
        setDatas(trendingIdols);
      }

      console.log(result);
    } catch (error) {
      console.log(
        "🚀 ~ file: OtherProfile.tsx:43 ~ handleUnsubscribe ~ error:",
        error
      );
    }
  };

  const handleSubscribe = async (userId: string, index: number) => {
    try {
      const accessToken = getItem(ACCESS_TOKEN) || "";

      if (!accessToken) return;
      const updatedDatas = [...trendingIdols];
      updatedDatas[index].isSubscribe = true;
      updatedDatas[index].numFan = updatedDatas[index].numFan + 1;

      setDatas(updatedDatas);

      const result = await subscribe(accessToken, userId);

      console.log(
        "🚀 ~ file: OtherProfile.tsx:218 ~ handleSubscribe ~ result:",
        result
      );

      if (!result) {
        setDatas(trendingIdols);
      }
    } catch (error) {
      console.log(
        "🚀 ~ file: OtherProfile.tsx:219 ~ handleSubscribe ~ error:",
        error
      );
    }
  };

  useEffect(() => {
    const f = async () => {
      try {
        setIsLoadingTrending(true);
        const accessToken = getItem(ACCESS_TOKEN) || "";
        if (!accessToken) return;
        const result = await getTiktokUserTrendingUsers(accessToken, 5);
        setTrendingIdols(result);
      } catch (error) {
      } finally {
        setIsLoadingTrending(false);
      }
    };
    f();
  }, []);

  return {
    datas,
    isLoading,
    val,
    setVal,
    handleSearch,
    handleKeyDown,
    handleUnsubscribe,
    handleSubscribe,
    currentTab,
    setCurrentTab,
    trendingIdols,
    isLoadingTrending,
  };
};
